import {lazy} from 'react';

export const ComboboxLazy = lazy(() => import(/* webpackChunkName: "combobox" */ '.'));
